var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('details-component',{attrs:{"gallery":_vm.gallery,"name":_vm.place.name,"address":_vm.place.address,"description":_vm.place.description,"tags":_vm.place.tags,"visible":_vm.visible},on:{"close":_vm.handleClose,"transitionEnd":_vm.setPlace}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e520b230","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Details/DetailsContainer.vue
// module id = null
// module chunks = 